<div class="parent-frame">
	<mat-drawer-container class="drawer-container" autosize>
		<mat-drawer #drawer class="drawer-flyout" mode="side">
			<mat-form-field class="full-width-input">
				<mat-label>ERP System Name</mat-label>
				<input matInput type="text" [(ngModel)]="txtERPSystemName">
			</mat-form-field>

			<mat-form-field class="full-width-input">
				<mat-label>Contact Person</mat-label>
				<input matInput type="text" [(ngModel)]="txtContactPerson">
			</mat-form-field>

			<mat-form-field class="full-width-input">
				<mat-label>Contact Email</mat-label>
				<input matInput type="text" [(ngModel)]="txtContactEmail">
			</mat-form-field>

			<mat-form-field class="full-width-input">
				<mat-label>Contact Phone</mat-label>
				<input matInput type="text" [(ngModel)]="txtContactPhone">
			</mat-form-field>

			<mat-form-field class="full-width-input">
				<mat-label>SystemId</mat-label>
				<input matInput type="text" [(ngModel)]="txtSystemId">
			</mat-form-field>


			<button mat-flat-button color="primary" (click)="saveNew()">Save New ERP System</button>

			<button mat-flat-button color="warn" (click)="cancelClicked(drawer)">Cancel</button>

		</mat-drawer>

		<div class="body-frame">
			<div class="nav-bar">
				<app-naviconbar></app-naviconbar>

			</div>

			<div class="nav-bar">
			
				<button mat-flat-button color="primary" (click)="drawer.open()">Add ERP System</button>
				<button mat-flat-button color="primary" (click)="refreshItems()">Refresh ERP System List</button>
			</div>

			<div>
				<table [ngClass]="{ 'loading-animation': isLoading }" mat-table [dataSource]="dataSource" class="mat-elevation-z8">

					<ng-container matColumnDef="id">
						<th mat-header-cell *matHeaderCellDef> Id </th>
						<td mat-cell *matCellDef="let item"> {{item.id}} </td>
					</ng-container>

					<ng-container matColumnDef="systemName">
						<th mat-header-cell *matHeaderCellDef> Name </th>
						<td mat-cell *matCellDef="let item"> {{item.systemName}} </td>
					</ng-container>

					<ng-container matColumnDef="contactPerson">
						<th mat-header-cell *matHeaderCellDef> Contact Name </th>
						<td mat-cell *matCellDef="let item"> {{item.contactPerson}} </td>
					</ng-container>

					<ng-container matColumnDef="contactEmail">
						<th mat-header-cell *matHeaderCellDef> Contact Email </th>
						<td mat-cell *matCellDef="let item"> {{item.contactEmail}} </td>
					</ng-container>

					<ng-container matColumnDef="contactPhone">
						<th mat-header-cell *matHeaderCellDef> Contact Phone </th>
						<td mat-cell *matCellDef="let item"> {{item.contactPhone}} </td>
					</ng-container>

					<ng-container matColumnDef="systemId">
						<th mat-header-cell *matHeaderCellDef> System Id </th>
						<td mat-cell *matCellDef="let item"> {{item.systemId}} </td>
					</ng-container>

					<ng-container matColumnDef="delButton">
						<th mat-header-cell *matHeaderCellDef> </th>
						<td mat-cell *matCellDef="let item"> <button mat-flat-button color="warn" (click)="deleteItem(item)">Delete</button> </td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;" (click)="rowClicked(row)"></tr>

				</table>
			</div>
		</div>

	</mat-drawer-container>
</div>
